import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PerformanceChartContainer from './components/PerformanceChartContainer';
import './components/index.scss';

const App = () => {
  const { i18n: _i18n } = useTranslation();
  useEffect(() => {
    const siteCoreLang = window.performanceChart?.isoCode || 'en-GB';
    _i18n.changeLanguage(siteCoreLang);
  }, []);
  return (
    <div className="wt-chart-container">
      <section className="m-top">
        <PerformanceChartContainer />
      </section>
    </div>
  );
};

export default App;
